export const environment = {
  production: false,
  BASE_URL: 'https://jk1940w4-3000.uks1.devtunnels.ms/',
};
